
<div>

  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.emailStyleable)">
    <panel-item>
      <label :for="selectedObjectModelAction.idForProp('email_style')" class="a-select-label">Style</label>
      <a-select
        v-model="selectedObjectModelAction.email_style"
        :options="emailStyleOptions"
        compress
        :id="selectedObjectModelAction.idForProp('email_style')">

      </a-select>
    </panel-item>

  </panel-block>
  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.formLinkable)"
               id="pn-form-view-restriction">

  <panel-item v-if="completersIncludeRelatedRecordHolder">
    <panel-title>Relationship with related record must already be established?
      <help-tooltip
        text="If yes, only users who already hold a record related to one of this object model type may take this action. If no, any potential related record-holders (can have a relationship but one is not yet established) can complete the action."
      ></help-tooltip>
    </panel-title>
    <yes-no-radio
      id="require-relationship"
      v-model="selectedObjectModelAction.require_relationship"
    ></yes-no-radio>
  </panel-item>

    <panel-item>
      <panel-title>Do you want to restrict who can view this form?</panel-title>
      <yes-no-radio
          id="restrict-form-viewers"
          v-model="selectedObjectModelAction.restrict_form_viewers"
      ></yes-no-radio>
    </panel-item>

     <panel-item>
      <panel-title>Do you want to open the form in a new tab?</panel-title>
      <yes-no-radio
          id="open-in-new-tab"
          v-model="selectedObjectModelAction.open_in_new_tab"
      ></yes-no-radio>
    </panel-item>

    <panel-item v-if="selectedObjectModelAction.restrict_form_viewers">
      <fill-form-permittees
        :id="selectedObjectModelAction.idForProp('form_viewers')"
        :permittees="selectedObjectModelAction.formViewersArray"
        :options="objectModelActionFormPermitteeVOptionSets"
        @create="selectedObjectModelAction.appendFormViewer($event)">
        Form Viewers
      </fill-form-permittees>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.availabilityConditionable)"
               id="pn-available-condition">
    <panel-item>
      <panel-title>Do you want this action to be available based on model fields?</panel-title>
      <yes-no-radio
          id="has-availability-condition"
          v-model="selectedObjectModelAction.has_availability_condition"
      ></yes-no-radio>
    </panel-item>

    <conditional-wrapper
      v-if="selectedObjectModelAction.has_availability_condition"
      :parent="selectedObjectModelAction"
      :field-definition="ObjectModelConditionalFields.ACTION_AVAILABLE"
      :has-otherwise-value="false"
      :conditional-rule-options="{includeBuiltInProperties: true}"
      :can-add-rule="Object.keys(selectedObjectModelAction.action_available_conditional_rule_sets).length === 0">
      <template #header>
        Available
      </template>
      <template #value="slotProps">
        <input type="hidden"
               v-model="slotProps.model[slotProps.fieldName]"
               value="true">
      </template>
      <template #default>
        <p>Never available</p>
      </template>
    </conditional-wrapper>

    <template v-if="!selectedObjectModelAction.is(ObjectModelActionType.DefaultAction)">
      <panel-item>
        <configure-relative-time-component
          id="action_availability_start"
          v-model="selectedObjectModelAction.action_availability_start"
          prop_key="action_availability_start"
          :model="selectedObjectModelAction"
          full-width
          include-built-in
          compress
          :options="[{label: 'Anytime', value: DurationType.never},
                    {label: 'On date', value: DurationType.fixedDate},
                    {label: 'Formula', value: DurationType.customFormula}]">
          {{ availabilityStartText }}
        </configure-relative-time-component>
      </panel-item>
      <panel-item>
        <configure-relative-time-component
          id="action_availability_end"
          v-model="selectedObjectModelAction.action_availability_end"
          prop_key="action_availability_end"
          :model="selectedObjectModelAction"
          full-width
          include-built-in
          compress
          :options="[{label: 'Indefinitely', value: DurationType.never},
                    {label: 'On date', value: DurationType.fixedDate},
                    {label: 'Formula', value: DurationType.customFormula}]">
          {{ availabilityEndText }}
        </configure-relative-time-component>
      </panel-item>
    </template>
  </panel-block>

  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.bulkActionable)" id="pn-allows-bulk">
    <panel-item>
      <panel-title>Can this action be taken in bulk?</panel-title>
      <yes-no-radio
          id="allows-bulk"
          v-model="selectedObjectModelAction.allows_bulk"
          :disabled="!$can('configureTakeInBulk', selectedObjectModelAction)"
      ></yes-no-radio>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.runProcessable) && selectedObjectModelAction.allows_bulk" id="pn-treat-as-bulk">
    <panel-item>
      <panel-title>Should this action be treated as an individual or bulk action?</panel-title>
      <div class="radio-inline">
        <input
          type="radio"
          id="treat-as-bulk-false"
          v-model="selectedObjectModelAction.treat_as_bulk"
          :value="false">
        <label for="treat-as-bulk-false">Individual</label>
      </div>
      <div class="radio-inline">
        <input
          type="radio"
          id="treat-as-bulk-true"
          v-model="selectedObjectModelAction.treat_as_bulk"
          :value="true">
        <label for="treat-as-bulk-true">Bulk</label>
      </div>
    </panel-item>
  </panel-block>

  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.confirmationCustomizable)" id="pn-confirmation-customization">
    <panel-item data-test="include-confirmation">
      <row>
        <column>
          <label>Include Confirmation?</label>
        </column>
        <suffix>
          <help-tooltip text="Configure the pop-up the user sees to confirm they want to take the action."></help-tooltip>
        </suffix>
      </row>
      <yes-no-radio
          id="include-confirmation"
          v-model="selectedObjectModelAction.include_confirmation"
          :disabled="selectedObjectModelAction.allows_bulk"
      ></yes-no-radio>
    </panel-item>

    <template v-if="selectedObjectModelAction.include_confirmation">
      <panel-item>
        <p v-if="confirmationHeader">{{confirmationHeader}}</p>
        <button @click="editConfirmation" type="button" class="btn grey-to-blue full-sz mb-2">
          Edit Confirmation
        </button>
      </panel-item>

      <panel-item v-if="selectedObjectModelAction.can(ObjectModelActionCapability.noteRequireable)" data-test="require-note">
        <row>
          <column>
            <label>Require a Note?</label>
          </column>
        </row>
        <yes-no-radio
            id="require-note"
            v-model="selectedObjectModelAction.require_note"
            :disabled="selectedObjectModelAction.allows_bulk"
        ></yes-no-radio>
      </panel-item>
    </template>
  </panel-block>


  <panel-block v-if="selectedObjectModelAction.can(ObjectModelActionCapability.loggable)">
    <panel-item>
      <row>
        <column>
          <label :for="selectedObjectModel.idForProp('is_logged')">Capture in Change Log?</label>
        </column>
        <suffix>
          <help-tooltip text="To track changes to this property select 'Yes'"></help-tooltip>
        </suffix>
      </row>
      <toggle-select
        :id="selectedObjectModel.idForProp('is_logged')"
        compress
        v-model="selectedObjectModelAction.is_logged"
      ></toggle-select>
    </panel-item>
  </panel-block>

  <panel-modal>
    <action-edit-confirmation-modal
      v-if="modalStateFor(vueModalID.editActionConfirmation).isVisible"
      :confirmation="editedConfirmation"
      :action="selectedObjectModelAction"
      :state="modalStateFor(vueModalID.editActionConfirmation)"
      @toggle-modal="toggleModal"
    ></action-edit-confirmation-modal>
  </panel-modal>
</div>
